import React from 'react';

export const TilePickerContext = React.createContext();
export const { Provider, Consumer } = TilePickerContext;
